export default __webpack_public_path__ + "static/media/748.cf18640b.png";